import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Cookies from 'js-cookie';

const Publicroute = ({ component: Component }) => {
    const location = useLocation();

    useEffect(() => {
        const searchParams = new URLSearchParams(location.search);
        const packageValue = searchParams.get("package");
        const region = searchParams.get("region") || '';
        const server = searchParams.get("server") || '';
        const images = searchParams.get("images");

        if (packageValue || images) {
            const queryString = `package=${packageValue || ''}&region=${region}&server=${server}&images=${images || ''}`;
            console.log("Saving to cookies:", queryString);

            // Cookies.set('redirectURLPublic', queryString, { expires: 1 });
            localStorage.setItem('redirectURLPublic', queryString);
        } else {
            console.log("Query parameters are missing. Cookies not updated.");
        }
    }, [location.search]);


    return <Component />;
};

export default Publicroute;
